module.exports = __webpack_public_path__ + "static/media/Oracle_logo.2d847ec3.svg";